import axios from 'axios'
import convertCoaching from '@/api/converters/coaching'

/**
 * Get list of coachings
 */
function getList () {
  return axios
    .get('coachings/')
    .then(response => response.data
      .map(convertCoaching)
      .sort((a, b) => {
        if (!a.dateAcceptance && !b.dateAcceptance) {
          return a.coach.name.toLowerCase() > b.coach.name.toLowerCase()
        } else if (!a.dateAcceptance && b.dateAcceptance) {
          return -1
        } else if (a.dateAcceptance && !b.dateAcceptance) {
          return 1
        }

        return b.dateAcceptance - a.dateAcceptance
      })
    )
}

/**
 * Get single coaching
 * @param {Number} id Coaching ID
 */
function getSingle (id) {
  return axios
    .get(`coachings/${id}/`)
    .then(response => convertCoaching(response.data))
}

/**
 * Create new coaching
 * @param {Object} data Coaching data
 * @param {4|6|8|12} data.estimate Estimated length
 * @param {0|1|2} data.type Type
 * @param {[String, String]} data.date Start and end date
 * @param {String} data.topic Topic
 * @param {String} data.objective Objective
 * @param {Number} data.coach Coach ID
 * @param {Number} data.coachee Coachee ID
 */
function create (data) {
  return axios
    .post('coachings/', {
      coaching_type: data.type,
      estimate: data.estimate,
      start_date: data.date[0],
      end_date: data.date[1],
      topic: data.topic,
      aim: data.objective,
      coach: data.coach,
      coachee: data.coachee
    })
}

/**
 * Update coaching
 * @param {Object} data Coaching data
 * @param {4|6|8|12} data.estimate Estimated length
 * @param {0|1|2} data.type Type
 * @param {[String, String]} data.date Start and end date
 * @param {String} data.topic Topic
 * @param {String} data.objective Objective
 */
function update (id, data) {
  return axios
    .patch(`coachings/${id}/`, {
      coaching_type: data.type,
      estimate: data.estimate,
      start_date: data.date && data.date[0],
      end_date: data.date && data.date[1],
      topic: data.topic,
      aim: data.objective
    })
}

/**
 * Cancel coaching invitation
 * @param {Number} id Coaching ID
 */
function cancel (id) {
  return axios
    .get(`coachings/${id}/cancel/`)
}

/**
 * Accept coaching as coach
 * @param {Number} id Coaching ID
 */
function accept (id) {
  return axios
    .get(`coachings/${id}/accept/`)
}

/**
 * Reject coaching as coach
 * @param {Number} id Coaching ID
 */
function reject (id) {
  return axios
    .get(`coachings/${id}/reject/`)
}

/**
 * Approve coaching as admin
 * @param {Number} id Coaching ID
 */
function approve (id) {
  return axios
    .get(`coachings/${id}/give_clearance/`)
}

/**
 * Decline coaching as admin
 * @param {Number} id Coaching ID
 */
function decline (id) {
  return axios
    .get(`coachings/${id}/decline/`)
}

/**
 * Finish coaching
 * @param {Number} id Coaching ID
 * @param {Object} data Form data
 * @param {Number} data.reason Reason ID
 * @param {String} data.comment Comment
 */
function finish (id, data) {
  return axios
    .post(`coachings/${id}/terminate/`, {
      termination_reason: data.reason,
      termination_comment: data.comment
    })
}

/**
 * Rate coaching
 * @param {Number} id Coaching ID
 * @param {Object} data Form data
 * @param {Number} data.rating Rating
 * @param {String} data.comment Comment
 */
function rate (id, data) {
  return axios
    .post(`coachings/${id}/finalize/`, {
      rating: data.rating,
      rating_comment: data.comment
    })
}

/**
 * Archive coaching
 * @param {Number} id Coaching ID
 */
function archive (id) {
  return axios
    .get(`coachings/${id}/file_away/`)
}

/**
 * Remove coaching
 * @param {Number} id Coaching ID
 */
function remove (id) {
  return axios
    .delete(`coachings/${id}/`)
}

export default {
  getList,
  getSingle,
  create,
  update,
  cancel,
  accept,
  reject,
  approve,
  decline,
  finish,
  rate,
  archive,
  remove
}
